
import {IonPage, IonContent} from '@ionic/vue'
export default {
  components: {IonPage,IonContent},
  name: "Goals"
}
